/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seller: NonNullable<unknown> }} Offerdetail_Hero_Offeredby2Inputs */

const id_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ditawarkan oleh ${i?.seller}`)
};

const ms_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ditawarkan oleh ${i?.seller}`)
};

const da_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilbydes af ${i?.seller}`)
};

const de_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Angeboten von ${i?.seller}`)
};

const en_us2_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offered by ${i?.seller}`)
};

const es_es2_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ofrecido por ${i?.seller}`)
};

const es_mx2_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ofrecido por ${i?.seller}`)
};

const fil_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inaalok ni ${i?.seller}`)
};

const fr_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Proposé par ${i?.seller}`)
};

const it_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offerto da ${i?.seller}`)
};

const hu_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajánlotta ${i?.seller}`)
};

const nl_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aangeboden door ${i?.seller}`)
};

const no_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilbudt av ${i?.seller}`)
};

const pl_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferowane przez ${i?.seller}`)
};

const pt_br2_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferecido por ${i?.seller}`)
};

const pt_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferecido por ${i?.seller}`)
};

const ro_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferit de ${i?.seller}`)
};

const fi_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarjoaa ${i?.seller}`)
};

const sv_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erbjuds av ${i?.seller}`)
};

const vi_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Được cung cấp bởi ${i?.seller}`)
};

const tr_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seller} tarafından sunuldu`)
};

const cs_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nabízí ${i?.seller}`)
};

const bg_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предлага се от ${i?.seller}`)
};

const ru_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предлагается ${i?.seller}`)
};

const uk_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пропонується ${i?.seller}`)
};

const ar_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مقدم من ${i?.seller}`)
};

const hi_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seller} द्वारा प्रस्तुत`)
};

const th_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เสนอโดย ${i?.seller}`)
};

const ja_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seller} 提供`)
};

const zh_cn2_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 ${i?.seller} 提供`)
};

const zh_hant1_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 ${i?.seller} 提供`)
};

const ko_offerdetail_hero_offeredby2 = /** @type {(inputs: Offerdetail_Hero_Offeredby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seller} 제공`)
};

/**
* | output |
* | --- |
* | "Offered by {seller}" |
*
* @param {Offerdetail_Hero_Offeredby2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_hero_offeredby2 = /** @type {((inputs: Offerdetail_Hero_Offeredby2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Hero_Offeredby2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_hero_offeredby2(inputs)
	if (locale === "ms") return ms_offerdetail_hero_offeredby2(inputs)
	if (locale === "da") return da_offerdetail_hero_offeredby2(inputs)
	if (locale === "de") return de_offerdetail_hero_offeredby2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_hero_offeredby2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_hero_offeredby2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_hero_offeredby2(inputs)
	if (locale === "fil") return fil_offerdetail_hero_offeredby2(inputs)
	if (locale === "fr") return fr_offerdetail_hero_offeredby2(inputs)
	if (locale === "it") return it_offerdetail_hero_offeredby2(inputs)
	if (locale === "hu") return hu_offerdetail_hero_offeredby2(inputs)
	if (locale === "nl") return nl_offerdetail_hero_offeredby2(inputs)
	if (locale === "no") return no_offerdetail_hero_offeredby2(inputs)
	if (locale === "pl") return pl_offerdetail_hero_offeredby2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_hero_offeredby2(inputs)
	if (locale === "pt") return pt_offerdetail_hero_offeredby2(inputs)
	if (locale === "ro") return ro_offerdetail_hero_offeredby2(inputs)
	if (locale === "fi") return fi_offerdetail_hero_offeredby2(inputs)
	if (locale === "sv") return sv_offerdetail_hero_offeredby2(inputs)
	if (locale === "vi") return vi_offerdetail_hero_offeredby2(inputs)
	if (locale === "tr") return tr_offerdetail_hero_offeredby2(inputs)
	if (locale === "cs") return cs_offerdetail_hero_offeredby2(inputs)
	if (locale === "bg") return bg_offerdetail_hero_offeredby2(inputs)
	if (locale === "ru") return ru_offerdetail_hero_offeredby2(inputs)
	if (locale === "uk") return uk_offerdetail_hero_offeredby2(inputs)
	if (locale === "ar") return ar_offerdetail_hero_offeredby2(inputs)
	if (locale === "hi") return hi_offerdetail_hero_offeredby2(inputs)
	if (locale === "th") return th_offerdetail_hero_offeredby2(inputs)
	if (locale === "ja") return ja_offerdetail_hero_offeredby2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_hero_offeredby2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_hero_offeredby2(inputs)
	return ko_offerdetail_hero_offeredby2(inputs)
});
export { offerdetail_hero_offeredby2 as "offerDetail.hero.offeredBy" }